import React from 'react';
import MuiAutocomplete, { AutocompleteProps as MuiAutocompleteProps } from '@material-ui/lab/Autocomplete';
import { TextField, TextFieldProps } from '../../../ui-kit';
import { Options } from './types';

type AutocompleteProps = MuiAutocompleteProps<Options, boolean | undefined, boolean | undefined, boolean | undefined>;

export type AutocompleteFieldProps = TextFieldProps & Omit<AutocompleteProps, 'renderInput'> & {
    name: string;
};

const Autocomplete: React.FC<AutocompleteFieldProps> = ({ options, label, onClick, margin, ...other }) => (
    <>
        {/*
        // @ts-ignore types from lab */}
        <MuiAutocomplete
            {...other}
            multiple
            disableCloseOnSelect
            options={options}
            getOptionLabel={(option: Options) => option.name}
            renderInput={(
                { InputProps: { className, ...restInputProps }, inputProps, id }
            ) => (
                <TextField
                    onClick={onClick}
                    margin={margin}
                    {...restInputProps}
                    inputProps={inputProps}
                    id={id}
                    label={label}
                />
            )}
        />
    </>
);

export default Autocomplete;
